import { render } from "./Ministry.vue?vue&type=template&id=61c49b40&scoped=true"
import script from "./Ministry.vue?vue&type=script&lang=js"
export * from "./Ministry.vue?vue&type=script&lang=js"

import "./Ministry.vue?vue&type=style&index=0&id=61c49b40&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c49b40"]])

export default __exports__